/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../api/SlotActionsProviderAPI'
], (stringResources, APIFactory, SlotActionsProviderAPI) => {

	return class RemoveShapeAction {

		constructor({ content, features }) {
			this.content = content;

			if(features) {
				features.SlotActions.registerProvider('removeShapeAction', this.getAPI());
			}
		}

		getSlotActionList(dataSlotId, itemIndex) {
			if (this._supportAction()) {
				return [
					{
						name: 'removeShapeAction',
						label:  stringResources.get('toolbarActionRmvShape'),
						text: stringResources.get('toolbarActionRmvShape'),
						icon: 'dashboard-shapeOff',
						type: 'Button',
						removeThenApplyAction: true,
						actions: {
							apply: this.removeShape.bind(this, dataSlotId, itemIndex)
						}
					}
				];
			}
			return [];
		}

		_supportAction() {
			return this.content.getPropertyValue('value.graphic.content') && this.content.getPropertyNameList().indexOf('value.graphic.content') !== -1;
		}

		removeShape() {
			this.content.setPropertyValue('value.graphic.content', null);
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [SlotActionsProviderAPI]);
			}
			return this._api;
		}
	};
});
